import { render } from 'solid-js/web';
import { MetaProvider } from '@solidjs/meta';
import { registerSW } from 'virtual:pwa-register';
import './styles/global.css'; // Global CSS zuerst!
import './panda.css';
import App from './App';
import { storage } from './utils/storage';
import './utils/pwaInstall'; // beforeinstallprompt früh abfangen
import './utils/errorReporter';
import { markUpdateAvailable, setServiceWorkerUpdater } from './utils/appUpdate';

// Wenn ein lazy-geladenes Modul nicht gefunden wird (404 nach Deployment),
// einmalig automatisch neu laden, damit der User die neue Version bekommt.
window.addEventListener('unhandledrejection', (event) => {
  const msg: string = event.reason?.message ?? '';
  if (msg.includes('Failed to fetch dynamically imported module') || msg.includes('Importing a module script failed')) {
    const RELOAD_KEY = 'chunk_reload_at';
    const last = Number(storage.session.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - last > 30_000) {
      storage.session.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
  }
});

// Service Worker registrieren. registerType 'prompt': ein neuer SW wartet, bis der
// Nutzer im Update-Banner „Jetzt laden“ wählt (kein erzwungener Reload mehr mitten
// in der Aktion). updateSW() sendet SKIP_WAITING und lädt beim Kontrollwechsel neu.
if ('serviceWorker' in navigator) {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      markUpdateAvailable('sw');
    },
    onRegistered(registration) {
      if (registration) {
        // Bei jedem Seitenaufruf einmal prüfen + alle 5 Minuten
        registration.update();
        setInterval(() => registration.update(), 5 * 60 * 1000);
      }
    },
    onRegisterError(error) {
      console.error('[PWA] Service Worker Registrierung fehlgeschlagen:', error);
    },
  });
  setServiceWorkerUpdater(updateSW);
}

const root = document.getElementById('root');
if (root) {
  render(() => (
    <MetaProvider>
      <App />
    </MetaProvider>
  ), root);
}
